<template>
    <transition name="slide-fade" >
        <div>
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h1 class="uk-heading-line uk-text-center">Why Fincor?</h1>
                    <p>
                        FINCOR has developed a reputation in the public and private sectors
                        for competent, dependable and affordable accounting and strategic
                        services. We work closely with our clients as financial partners and
                        trusted advisors providing a first-class boutique service to meet your
                        individual needs.
                    </p>
                    <p>
                        We are experienced in providing full financial management and
                        strategic services to businesses and agencies with annual revenues of
                        less than $250 thousand to those with annual revenues of over CI$100
                        million. Each client and each service package is unique; however, our
                        personalized approach to service remains the same regardless of the
                        client or size of business.
                    </p>
                </div>
            </div>
            <!--<div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet">Licensed Practitioner</h3>
                    <div uk-grid>
                        <div class="uk-width-auto@m">
                            <img src="../../public/CIIPA.jpg" alt="" style="max-width: 250px; max-height: 250px; width: auto; height: auto;">
                        </div>
                        <div class="uk-width-expand@m">
                            <p>
                                Any person who offers services as a public accountant or engages in
                                public practice requires a valid license issued under Section 11 or 12
                                in the Accountants Law.
                            </p>
                            <p>
                                FINCOR is a licensed Public Practice Firm under Section 38(3) of the
                                Accountants Law, and is subject to oversight and quality assurance
                                monitoring by the Cayman Islands Institute of Public Accountants
                                (CIIPA). This enables us to legally provide attestation and audit
                                services under the Accountant’s Law.
                            </p>
                        </div>
                    </div>
                </div>
            </div>-->
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h3 class="uk-heading-bullet">Board certified accountants</h3>
                    <div uk-grid>
                        <div class="uk-width-auto@m">
                            <img src="../../public/acca.jpg" alt="" style="max-width: 250px; max-height: 250px; width: auto; height: auto;">
                        </div>
                        <div class="uk-width-expand@m">
                            <p class="">
                                <br><br>
                                FINCOR has Board certified accountants who are CPA and ACCA
                                qualified. Our clients are therefore assured that their financial affairs
                                are handled by experienced and qualified professionals.
                            </p>
                            <!--<p>
                                FINCOR is a licensed Public Practice Firm under Section 38(3) of the
                                Accountants Law, and is subject to oversight and quality assurance
                                monitoring by the Cayman Islands Institute of Public Accountants
                                (CIIPA). This enables us to legally provide attestation and audit
                                services under the Accountant’s Law.
                            </p>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="testStep">
                <div class="uk-padding " style="background: rgba(255, 255, 250, 0.9)">
                    <div class="uk-container uk-container-large">
                        <h2 class="uk-heading-line uk-text-center h2Style ">Company Strategy</h2>
                        <div class="uk-child-width-1-2@m uk-child-width-1-3@l" uk-grid>
                            <div>
                                <h3 class="uk-heading-bullet ">Purpose</h3>
                                <p class=" ">
                                    To be a leader in the domestic accounting industry
                                    by providing our clients with quality accounting and financial
                                    services with a personalized approach.
                                </p>
                            </div>
                            <div>
                                <h3 class="uk-heading-bullet ">Vision Statement</h3>
                                <p class=" ">
                                    FINCOR will offer superior financial management and
                                    corporate services to small and medium sized enterprises in
                                    the Cayman Islands. We will deliver value for money through
                                    personalized service, technology, and our team of competent,
                                    motivated and professional individuals.
                                </p>
                            </div>
                            <div>
                                <h3 class="uk-heading-bullet">Mission Statement</h3>
                                <p>
                                    Our mission is to provide client centered
                                    business partnerships that meet or exceed expectations. We
                                    will be recognized as an industry leader through efficient,
                                    effective and economical service, and the value we place on
                                    our employees, partners and community.
                                </p>
                            </div>

                        </div>
                      <div class="uk-width-1-1">
                        <div>
                          <h3 class="uk-heading-bullet">Core Values</h3>
                          <ul class="uk-list uk-list-bullet">
                            Our word is our bond. We will be honest,
                            dependable and committed in the delivery of our services.
                            <li>We are committed to quality, fairness, and ethical dealings in all that we do.</li>
                            <li>We will form long lasting relationships with our clients and foster a culture based on trust, respect and good faith.</li>
                            <li>Our environment will be defined by honesty, mutual respect and professionalism.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "wf",
      metaInfo: {
        title: ' Why Choose FINCOR',
        meta: [{
          content: 'FINCOR has developed a reputation in the public and private sectors for competent, dependable and affordable accounting and strategic services. We work closely with our clients as financial partners and trusted advisors providing a first-class boutique service to meet your individual needs.'
        }]
      }
    }
</script>

<style scoped>
    .testStep{
        background-image: url('~@/assets/fincor_lion_dark.png');
        background-size: cover;
    }
    .whiteColor{
        color: white !important;
    }
</style>